import {
  selectManagerNotificationBannerContent,
  selectManagerReportEmailContent,
  selectManagerReportEmailContentSubject,
  selectSendManagerReportEveryXDays,
} from './selectors'

const buildNotifyManagerContent = (state) => ({
  managerNotificationBanner: {
    text: selectManagerNotificationBannerContent(state),
  },
  managerReportEmail: {
    subject: selectManagerReportEmailContentSubject(state),
    body: selectManagerReportEmailContent(state),
  },
})

export const buildManagerNotificationSavePayload = (state) => {
  const sendManagerReportEveryXDays = selectSendManagerReportEveryXDays(state)

  if (!sendManagerReportEveryXDays) {
    return {
      managerNotificationBanner: null,
      managerReportEmail: null,
    }
  }

  return buildNotifyManagerContent(state)
}
